import { useParams } from 'react-router-dom'
import { useUserContext } from '../../../context/UserProvider'
import { useQuery } from 'react-query'
import axios from 'axios'
import { format } from 'path'
import { formatMoney } from '../components/CreateFinanceApplication'
import { ArrowIcon, HomeIcon, PhoneIcon, PlugIcon, UserIcon } from '../components/icons'
import { useReducer, useState } from 'react'
import { doc } from 'prettier'
import { initial } from 'lodash'
import { featureConfig } from '../helpers/featureConfig'

export function ContractDetails() {
  const { id } = useParams()
  const user = useUserContext() as any
  function reducer(state, action) {
    switch (action.type) {
      case 'ADD':
        return [...state, action.payload]
      default:
        return state
    }
  }
  const [messages, setMessages] = useReducer(reducer, [])
  const [message, setMessage] = useState('')
  const { isLoading, isFetching, data, isError } = useQuery({
    queryKey: ['flows', 'initiate-contract'],
    queryFn: async () => {
      const data = await axios.get(`/api/flows?flowDefinitionId=initiate-contract&sort=createdAt&dir=-1`, {
        headers: {
          Authorization: `Bearer ${user.newUserData?.access_token}`
        }
      })
      return data.data?.flows
    }
  })

  const intialDataById = data?.find((contract) => contract.referenceId === id)
  const findById = data?.find((contract) => contract.referenceId === id).data?.currentContractDetails
  const contract = formatContractData(findById, id)

  function handleKeyUp(event) {
    if (event.key === 'Enter') {
      handleSendMessage()
    }
  }

  function handleSendMessage() {
    if (!message) return
    setMessages({ type: 'ADD', payload: message })
    setMessage('')
  }

  if (isLoading) {
    return (
      <div className="w-full h-full flex items-center justify-center flex-col gap-8">
        <div className="w-8 h-8 animate-spin bg-transparent border-2 border-t-primary rounded-full" />
        <p>Loading...</p>
      </div>
    )
  }

  const progress = [
    {
      status: 'Contract Sent',
      date: new Date(intialDataById.updatedAt).toDateString(),
      message: 'Contract sent to customer'
    },

    {
      status: 'Contract Created',
      date: new Date(contract.created).toDateString(),
      message: 'Contract created successfully'
    },
    {
      status: 'Contract Initiated',
      date: new Date(contract.created).toDateString(),
      message: 'Contract sent to customer'
    }
  ]

  return (
    <div id="page" className=" text-primary bg-white h-full popUp relative w-full">
      <div className="fixed top-64 left-[28rem] w-full">
        <img
          className="relative table w-[500px]"
          src={`${'https://cc.blue.link-demo.stacc.dev/'}${contract.vehicle?.imageUrl}`}
          alt="Mercedes"
        />
      </div>
      <div className="overflow-scroll w-full  max-h-[100%] px-4 lg:px-28">
        <div className=" py-24 xl:grid flex flex-col xl:grid-cols-[2fr_1fr] gap-8 relative">
          <div className="w-full overflow-scroll flex flex-col justify-between h-fit">
            <div className="pl-4 flex z-20 flex-col gap-2">
              <p className="text-3xl">{contract.vehicle.brand}</p>
              <p className="">
                {contract.vehicle.modelName} - {contract.vehicle.variantName}
              </p>
              <div className="flex gap-2 items-center pt-2 pb-96">
                <div className="bg-primary font-bold text-white border rounded-md border-primary px-2 py-1">
                  {formatMoney(contract.financedAmount)}
                </div>
                <div className="bg-background border rounded-md border-primary px-2 py-1">
                  <PlugIcon />
                </div>
                <div className="bg-background border rounded-md border-primary px-2 py-1">
                  {contract?.vehicle?.modelYear}
                </div>
              </div>
            </div>
            <div className="flex flex-col gap-8  z-20">
              <div className="p-4 px-8 glass border rounded-md flex flex-col gap-4">
                <h1 className="text-xl">Contract Details</h1>
                <div className="flex items-center bg-white bg-opacity-50 p-4 rounded-md justify-between">
                  <div className="flex flex-col gap-1 text-sm">
                    <p className="">Created</p>
                    <p>{new Date(contract.created).toDateString()}</p>
                  </div>
                  <div className="flex flex-col gap-1 text-sm">
                    <p className="">Financed Amount</p>
                    <p>{formatMoney(contract.financedAmount)}</p>
                  </div>
                  <div className="flex flex-col gap-1 text-sm">
                    <p className="">Terms</p>
                    <p>{contract.terms}</p>
                  </div>
                  <div className="flex flex-col gap-1 text-sm">
                    <p className="">Monthly Payment</p>
                    <p>{formatMoney(contract.totalMonthlyIncVat)}</p>
                  </div>
                </div>
              </div>
              <div className="w-full glass border p-4 rounded-md flex flex-col gap-4">
                <div className="pl-4">
                  <p className="text-xl">Required Documents</p>
                </div>
                <div className="flex justify-between p-4 gap-8 flex-col lg:flex-row">
                  <div className="w-full flex flex-col gap-2">
                    <p>Invoice</p>
                    <div className="w-full hover:animate-pulse bg-white bg-opacity-50 rounded-md cursor-pointer text-gray-500 h-full min-h-[160px] border-dotted border-2 flex items-center justify-center border-gray-500">
                      <p>Upload file</p>
                    </div>
                    <p className="text-xs text-gray-400">No file(s) uploaded</p>
                  </div>
                  <div className="w-full flex flex-col gap-2">
                    <p>Tasks</p>
                    <div className="flex items-center justify-between bg-white bg-opacity-50 p-4 border rounded-md">
                      <p>Registration Complete</p>
                      <button className="w-fit px-8 hover:rounded-xl transition-all ease-in-out text-background  bg-primary border-primary border-2 items-center text-backgrobg-background rounded-md shadow-md p-4 flex flex-col">
                        Confirm
                      </button>
                    </div>
                    <div className="flex items-center justify-between bg-white bg-opacity-50 p-4 border rounded-md">
                      <p>Private Contract</p>
                      <p className="text-yellow-600">Awaiting signature</p>
                    </div>
                    <div className="flex items-center justify-between bg-white bg-opacity-50 p-4 border rounded-md">
                      <p>Repurchase Contract</p>
                      <p className="text-yellow-600">Awaiting signature</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="flex gap-4 w-full justify-between [&>*]:w-full">
                <div>
                  <Changelog intialDataById={intialDataById} />
                </div>
                <Progress progress={progress} />
              </div>
            </div>
          </div>
          <div className="flex flex-col gap-8">
            <div className="p-4 glass border bg-opacity-50 rounded-md flex flex-col gap-8">
              <h1 className="text-xl p-2">Customer Details</h1>
              <div className="flex flex-col gap-4">
                <div className="w-full pl-6 p-4 gap-8 border flex items-center rounded-md bg-background bg-opacity-50">
                  <UserIcon />
                  <div>
                    <p className="text-sm">Name</p>
                    <p className="text-xl">
                      {contract.person?.FirstName} {contract.person?.LastName}
                    </p>
                  </div>
                </div>
                <div className="w-full pl-6 p-4 gap-8 border flex items-center rounded-md bg-background bg-opacity-50">
                  <HomeIcon />
                  <div>
                    <p className="text-sm">Address</p>
                    <p className="text-lg">{contract.person?.Address}</p>
                  </div>
                </div>
                <div className="w-full pl-6 p-4 gap-8 border flex items-center rounded-md bg-background bg-opacity-50">
                  <PhoneIcon />
                  <div>
                    <p className="text-sm">Phone</p>
                    <p className="text-lg">{contract.person?.Phone}</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="w-full glass border p-4 rounded-md">
              <div className="pl-2 flex flex-col gap-4">
                <p className="text-xl p-2">Customer Tasks</p>
                <div className=" bg-white border p-4 rounded-md bg-opacity-50 flex justify-between">
                  <p className="">Customer Information</p>
                  <p className="text-yellow-600">Waiting for customer</p>
                </div>
              </div>
            </div>
            <div className="p-4 h-[600px] glass border rounded-md flex flex-col gap-4">
              <div className="bg-background overflow-scroll shadow-md border w-full h-full rounded-md px-8 pb-8 py-4 flex flex-col gap-2">
                <p className="text-xs w-full text-center pb-8">Connected</p>
                <div className="flex gap-1 flex-col popUp">
                  <p className="text-xs">Caseworker</p>
                  <div className="bg-primary text-white px-4 py-2 w-fit rounded-md text-sm max-w-[75%]">
                    <p>Hello! How may I assist you today?</p>
                  </div>
                </div>
                {messages?.length > 0 && (
                  <div className="flex items-end gap-1 flex-col">
                    <p className="text-xs">You</p>
                    {messages.map((message, index) => (
                      <p
                        key={message}
                        className="bg-background popUp border text-primary px-4 py-2 w-fit rounded-md text-sm max-w-[75%]"
                      >
                        {message}
                      </p>
                    ))}
                  </div>
                )}
              </div>
              <div className="relative w-full flex">
                <input
                  value={message}
                  id="chat"
                  className="py-4 max-w-full px-2 pl-4 rounded-md shadow-md border font-normal text-sm w-full transition-all ease-in-out"
                  onChange={(e) => setMessage(e.target.value)}
                  onReset={() => setMessage('')}
                  type="textarea"
                  contentEditable
                  onKeyUp={handleKeyUp}
                  placeholder="Write a message"
                />
                <button
                  onClick={() => handleSendMessage()}
                  className=" h-full right-0 bg-primary text-white px-8  rounded-r-md shadow-md border font-normal text-sm focus-visible:px-8 transition-all ease-in-out"
                >
                  Send
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export const formatContractData = (contract, id) => {
  return {
    status: contract?.Contract?.ContractStatus,
    contractId: id,
    created: contract?.Contract?.CreationDate,
    terms: contract?.Contract?.Period,
    financedAmount: contract?.CalculationResult?.Leasing?.TotalFinancingSum,
    residualValue: contract?.CalculationResult?.Leasing?.TotalResidualValue,
    totalMonthlyIncVat: contract?.CalculationResult?.Leasing?.TotalMonthlyPaymentInclVat,
    vehicle: {
      brand: contract?.Contract?.Vehicle?.BrandName,
      modelName: contract?.Contract?.Vehicle?.ModelName,
      modelYear: contract?.Contract?.Vehicle?.ModelYear,
      engineType: contract?.Contract?.Vehicle?.EngineType,
      variantName: contract?.Contract?.Vehicle?.VariantName,
      weight: contract?.Contract?.Vehicle?.Weight,
      price: contract?.Contract?.Vehicle?.Price,
      imageUrl: contract?.Contract?.Vehicle?.ImageUrl
    },
    organization: contract?.Contract?.Buyer?.Organisation,
    person: contract?.Contract?.Buyer?.Person
  }
}

export function Changelog({ intialDataById }) {
  return (
    <>
      <div className="h-fit w-full relative">
        <div className="px-8 py-4 glass border rounded-md flex flex-col gap-8 relative max-h-[400px] overflow-y-scroll">
          <h1 className="text-xl">Changelog</h1>
          {intialDataById?.data?.contractUpdates?.[0]?.length > 0 ? (
            intialDataById?.data?.contractUpdates?.[0]?.map((update, index) => (
              <div key={index} className="flex flex-col gap-2 p-4 bg-white rounded-md border">
                <div>
                  <p>Contract Key:</p>
                  <p className="text-xs">{update?.key}</p>
                </div>
                {update?.type === 'changed' ? (
                  <div className="text-xs flex items-center gap-8">
                    <p className="text-xs">{!update.old ? 'No previous value' : update.old}</p>
                    <ArrowIcon />
                    {update?.value && <p className="text-xs">{update.value}</p>}
                  </div>
                ) : (
                  <p className="text-xs bg-red-300 text-red-500 px-4 py-1 border border-red-500">Removed</p>
                )}
              </div>
            ))
          ) : (
            <div className="min-h-[100px] w-full flex items-center justify-center">
              <p className="pb-4">No changes have been made to contract</p>
            </div>
          )}
        </div>
        {/*         <div className="w-full from-white via-white bg-gradient-to-t to-transparent absolute h-[35px] bottom-0 left-0 " />
         */}{' '}
      </div>
    </>
  )
}

export function Progress({ progress }) {
  return (
    <div className="px-8 h-fit py-4 glass border rounded-md flex flex-col gap-8 relative">
      <h1 className="text-xl">Contract Progress</h1>
      <div>
        {progress.map((step, index) => (
          <div key={index} className="flex gap-8 min-h-[60px]">
            <div>
              <p className="font-bold">Date</p>
              <p className="w-[8ch] text-gray-500">
                {step.date.split(' ')[2]} {step.date.split(' ')[1]}
              </p>
            </div>
            {index === 0 ? (
              <div className="flex items-center flex-col">
                <div className="w-[10px] h-[12px] rounded-full bg-white border border-gray-400 flex items-center justify-center">
                  <div className="w-[2px] h-[2px] bg-primary animate-ping" />
                </div>
                <div className="h-full w-[2px] bg-gray-400" />
              </div>
            ) : index === 1 ? (
              <div className="flex items-center flex-col">
                <div className="w-[10px] h-[12px] rounded-full bg-primary border border-primary" />
                <div className="h-full w-[2px] bg-primary" />
              </div>
            ) : (
              <div className="flex items-center justify-center w-[10px] flex-col">
                <div className="h-full w-[2px] bg-primary" />
              </div>
            )}
            <div className="flex items-start w-[16ch]">
              <p>{step.status}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
